import { IconImage } from '@moovly/ui';
import * as React from 'react';
import { BackofficeRoute } from '../../types/route.interfaces';
import LibrariesPage from './pages/Libraries';

const libraryRoutes: BackofficeRoute[] = [
  {
    sidebar: {
      icon: IconImage,
      translationKey: 'menu.libraries',
    },
    path: '/libraries',
    element: <LibrariesPage />,
  },
];

export default libraryRoutes;
